/*@flow*/
import L from 'leaflet';

// @method cloneLatLng(LatLng): L.LatLng
// Clone the latLng and return a new LatLng object.
export function cloneLatLng(latlng: Leaflet$LatLng): any {
  return L.latLng(latlng.lat, latlng.lng);
}

// closeTo checks whether two points are close to each other.
export function closeTo(
  point1: Leaflet$LatLng | Leaflet$Point,
  point2: Leaflet$LatLng | Leaflet$Point
): boolean {
  return (
    Math.abs(point1.distanceTo(point2)) < 9 * (window.devicePixelRatio || 1)
  );
}

// Clone the latLng point or points or nested points and return an array with those points
export function cloneLatLngs(
  latlngs: any[] | any[][]
): Leaflet$LatLng[] | Leaflet$LatLng[][] {
  let clone = [];
  latlngs.forEach(latlng => {
    // Check for nested array (Polyline/Polygon)
    if (Array.isArray(latlng)) {
      clone.push(cloneLatLngs(latlng));
    } else {
      clone.push(cloneLatLng(latlng));
    }
  });
  if (Array.isArray(clone[0])) {
    return ((clone: any): Leaflet$LatLng[][]);
  }
  return ((clone: any): Leaflet$LatLng[]);
}

// Check to see if points are in counterclockwise order
function _checkCounterclockwise(p, p1, p2) {
  return (p2.y - p.y) * (p1.x - p.x) > (p1.y - p.y) * (p2.x - p.x);
}

// @method segmentsIntersect(): boolean
// Checks to see if two line segments intersect. Does not handle degenerate cases.
// http://compgeom.cs.uiuc.edu/~jeffe/teaching/373/notes/x06-sweepline.pdf
export function segmentsIntersect(
  p: Leaflet$Point,
  p1: Leaflet$Point,
  p2: Leaflet$Point,
  p3: Leaflet$Point
): boolean {
  return (
    _checkCounterclockwise(p, p2, p3) !== _checkCounterclockwise(p1, p2, p3) &&
    _checkCounterclockwise(p, p1, p2) !== _checkCounterclockwise(p, p1, p3)
  );
}
